// extracted by mini-css-extract-plugin
export default {"section":"lotsStockTable_section__AXOk8"};